import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const DateLabel = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 12 * size : 12)}px;
  font-weight: normal;
  letter-spacing: 0.12px;
  line-height: ${({ size }) => (size ? 18 * size : 18)}px;
`

export default DateLabel
